import * as React from "react";
import { connect } from "react-redux"
import { get } from "lodash";

import { IAppState } from "../../../models/IAppState";
import { UserFitnessActions } from "../../../actions/UserFitnessActions";

import { IUserFitnessPlanRequestParams, IUserFitnessManagedPlanParams } from "./interface";
import TransformPatientWeeklyPlan from "./WeeklyPlanContainer/TransformPatientWeeklyPlan";


const PatientTransformContainer: React.FC<any> = props => {

    const { userId, fetchUserFitnessPlan, coachId, fetchUserManagedFitnessPlan, userProfile } = props;

    return (
        <div>
            <TransformPatientWeeklyPlan
                fetchUserFitnessPlan={fetchUserFitnessPlan}
                userId={userId}
                coachId={coachId}
                fetchUserManagedFitnessPlan={fetchUserManagedFitnessPlan}
                userProfile={userProfile} />
        </div>
    )
}

const mapStateToProps = (state: IAppState) => ({
    userId: get(state.patientCompleteInfo, "profile.curefitUserId", null),
    userProfile: get(state.patientCompleteInfo, "profile", null),
    coachId: get(state.accountData, "id", null)
});

const mapDispatchToProps = (dispatch: React.Dispatch<any>) => ({
    fetchUserFitnessPlan: (requestParams: IUserFitnessPlanRequestParams) => UserFitnessActions.fetchUserFitnessPlan(requestParams),
    fetchUserManagedFitnessPlan: (requestParams: IUserFitnessManagedPlanParams) => UserFitnessActions.fetchUserFitnessManagedPlan(requestParams),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientTransformContainer);
